(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('painelEdicaoCorrecao', PainelEdicaoCorrecao);

  function PainelEdicaoCorrecao() {
    return {
      restrict: 'E',
      templateUrl: 'views/painel_propriedade/correcao/_edicao.html',
      controller: 'CorrecaoSoloCtrl'
    };
  }

}());
